import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";;

const ProjectShowComponent = (props) => {

  const {t} = props;
  const {action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [projectStatuses, setProjectStatuses] = useState([]);
  const formatDateValue = window.App?.formatDateValue;

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const currentStatus = projectStatuses.find(
    item => item.id === formData?.project_status?.id
  );

  const statusColor = currentStatus?.color || '#883cae';

  useEffect(() => {
    apiCall('get', '/api/v2/project-status?' + JSON.stringify({
      first: 0,
      rows: 9999,
      page: 0,
    }))
      .then(response => {
        setProjectStatuses(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    if (id && action === 'read') {
      setLoading(true);
      apiCall('get', '/api/v2/project/' + id)
        .then(response => {
          setFormData(response.data.data)
          props?.onLoaded?.(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.state.rerenderProjectShow, id])

  return (
    <div
      className={"project-form widget status-color-block"}
      style={{'--status-color': statusColor}}
    >
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="last_name">{t('columnStatus2')}</label>
            <span className="p-d-block fake-input">
              {formData?.project_status?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="first_name">{t('projectNumber')}</label>
            <span className="p-d-block fake-input">
              {formData.project_number}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-12"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName')}</label>
            <span className="p-d-block fake-input">
              {formData.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnArchivedProject')}</label>
            <span className="p-d-block fake-input">
              {formData.archived ? <i className="pi pi-check text-success" /> : <i className="pi pi-times text-danger" />}
            </span>
          </div>
        </div>
        {formData?.project_type?.value_partner !== 'disabled' &&
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="partner_name">{t('columnPartner')}</label>
              <span className="p-d-block fake-input">
                {formData?.partner?.name}
              </span>
            </div>
          </div>
        }
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="project_type_name">{t('columnType')}</label>
            <span className="p-d-block fake-input">
              {formData?.project_type?.name}
            </span>
          </div>
        </div>
        {formData?.project_type?.value_location !== 'disabled' &&
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('columnLocation')}</label>
              <span className="p-d-block fake-input">
                {formData?.location?.name}
              </span>
            </div>
          </div>
        }
        {formData?.project_type?.warehouse_mode !== 'NONE' &&
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="warehouse">{t('columnWarehouse')}</label>
              <span className="p-d-block fake-input">
                {formData?.warehouse?.name}
              </span>
            </div>
          </div>
        }
        {formData?.project_type?.value_deadline !== 'disabled' &&
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="deadline.name">{t('columnDeadline')}</label>
              <span className="p-d-block fake-input">
                {formatDateValue?.(formData?.deadline) || <span style={{color: '#a8a8a8'}}>?</span>}
              </span>
            </div>
          </div>
        }
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_at">{t('columnCreatedAt')}</label>
            <span className="p-d-block fake-input">
              {formatDateValue?.(formData?.created_at, 'YYYY-MM-DD HH:mm:ss') || <span style={{color: '#a8a8a8'}}>?</span>}
            </span>
          </div>
        </div>
        {formData?.value_warranty_expiry_date !== 'disabled' && (
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="warranty_expiry_date">{t('fieldWarrantyExpiryDate')}</label>
              <span className="p-d-block fake-input">
                {formatDateValue?.(formData?.warranty_expiry_date) || <span style={{color: '#a8a8a8'}}>?</span>}
              </span>
            </div>
          </div>
        )}
        {formData?.created_by_name &&
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_by_name">{t('columnCreatedBy')}</label>
            <span className="p-d-block fake-input">
              {formData?.created_by_name}
            </span>
          </div>
        </div>
        }
        {formData?.note &&
        <div className={"p-col-12"}>
          <div className="p-field p-fluid">
            <label htmlFor="note">{t('columnComment')}</label>
            <div className="p-d-block fake-input offer-note" 
              dangerouslySetInnerHTML={{ __html: formData.note || '' }}>
            </div>
          </div>
        </div>
        }
        {/* <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="has_subcontractor">{t('columnSubcontractor')}</label>
            <span className="p-d-block fake-input">
              {formData.has_subcontractor === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </span>
          </div>
        </div> */}
      </div>


    </div>
  )
}
export default withTranslation('common')(ProjectShowComponent);
